import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const filters = {
  //订单模块开始
  distributionStatus(val) {
    const obj = {
      0: '未配货',
      1: '部分配货',
      2: '全部配货',
      null: '-',
      undefined: '-',
    }
    return obj[val]
  },
  orderStatus(type) {
    const obj = {
      0: '未知状态',
      1: '待买家付款', // 0-0-0-0
      2: '已支付，待配货', // 2-0-0-0
      3: '已支付，待配货', // 2-2-0-0
      4: '已支付，待配货', // 2-1-0-0
      51: '已部分配货，待发货', // 2-1-1-0
      // 52: '已完成', // 2-1-2-2
      5: '已全部配货，待发货', // 2-1-2-0
      6: '已部分配货，待收货', // 3-1-1-1
      7: '已发货，待收货', // 3-1-2-2、3-1-2-1
      8: '已完成', // 4-1-2-2、5-1-2-2、10-1-2-2
      9: '已取消', // 10-0-0-0
      10: '已部分配货，待发货', // 2-2-1-0
      11: '已部分配货，待收货', // 3-2-1-1
      12: '已完成', // 4-1-2-1、5-1-2-1、10-1-2-1
      13: '已完成', // 4-1-1-1、5-1-1-1、10-1-1-1
      14: '已完成', // 4-2-1-1、5-2-1-1、10-2-1-1
      15: '已完成', // 10-2-1-1
      null: '-',
      undefined: '-',
    }
    return obj[type]
  },
  orderSkuStatus(type) {
    const obj = {
      0: '未知状态',
      1: '待配货',
      2: '待配货',
      3: '已部分配货，待发货',
      4: '已部分配货，待发货',
      5: '已全部配货，待发货',
      6: '已部分配货，部分发货',
      61: '已全部配货，部分发货',
      7: '已部分配货，部分发货',
      71: '已全部配货，部分发货',
      8: '已全部配货，部分发货',
      9: '已部分配货，部分发货',
      10: '已完结',
      11: '已取消',
      null: '-',
      undefined: '-',
    }
    return obj[type]
  },
  tailPayStatus(type) {
    const obj = {
      0: '无需付款',
      1: '已支付定金',
      2: '已支付尾款',
      90: '违约',
      98: '已支付定金取消',
      99: '已支付尾款取消',
      null: '-',
      undefined: '-',
    }
    return obj[type]
  },

  customerType(type) {
    const obj = {
      2: '普通会员',
      4: '分享官',
      12: '分享官(导购)',
      null: '-',
      undefined: '-',
    }
    return obj[type]
  },
  notifyWarehouseStatus(val) {
    const obj = {
      0: '未通知',
      1: '已通知',
      2: '通知失败',
      99: '已取消',
      undefined: '-',
      null: '-',
    }
    return obj[val]
  },
  payType(val) {
    const obj = {
      2: '微信零钱',
      4: '积分',
      8: '余额',
      16: '红包',
      32: '支付宝',
      64: '其他',
      null: '-',
      undefined: '-',
    }
    return obj[val]
  },
  interceptType(val) {
    const obj = {
      0: '手动拦截',
      20: '拦截策略',
      40: '配货拦截',
      null: '-',
      undefined: '-',
    }
    return obj[val]
  },
  lastReviewerStatus(val) {
    const obj = {
      0: '未审核',
      1: '已审核',
      2: '待人工处理',
      null: '-',
      undefined: '-',
    }
    return obj[val]
  },

  platformType(val) {
    const obj = {
      1: '小程序',
      10: '抖音小店',
      11: '微信小店',
      12: '外渠道平台',
      null: '-',
      undefined: '-',
    }
    return obj[val]
  },
  fromType(val) {
    const obj = {
      1: '平台订单',
      2: '手工订单',
      3: '其他',
      null: '-',
      undefined: '-',
    }
    return obj[val]
  },
  //订单模块结束

  // 售后订单开始
  afterOrderType(val) {
    const obj = {
      0: '退款',
      1: '退货',
      2: '退货退款',
      null: '-',
      undefined: '-',
    }
    return obj[val]
  },
  applyOrderType(val) {
    const obj = {
      0: '买家',
      1: '卖家',
      null: '-',
      undefined: '-',
    }
    return obj[val]
  },
  afterSaleStatus(val) {
    const obj = {
      0: '售后中',
      1: '售后中',
      2: '已售后',
      null: '-',
      undefined: '-',
    }
    return obj[val]
  },
  deliveryStatus(val) {
    const obj = {
      0: '未出库',
      1: '部分出库',
      2: '全部出库',
      null: '-',
      undefined: '-',
    }
    return obj[val]
  },
  onTheState(val) {
    const obj = {
      0: '未出库',
      2: '全部出库',
      null: '-',
      undefined: '-',
    }
    return obj[val]
  },

  virtualOrderStatus(val) {
    const obj = {
      0: '待买家付款',
      1: '已支付',
      5: '已完成',
      99: '已取消',
      null: '-',
      undefined: '-',
    }
    return obj[val]
  },

  payTypeCode(val) {
    const obj = {
      2: '微信零钱',
      4: '积分',
      8: '余额',
      16: '红包',
      32: '支付宝',
      64: '其他',
      null: '-',
      undefined: '-',
    }
    return obj[val]
  },

  salesInsuranceStatus(val) {
    const obj = {
      0: '待支付',
      1: '待生效',
      2: '保障中',
      3: '已赔付',
      99: '已失效',
      null: '-',
      undefined: '-',
    }
    return obj[val]
  },

  // 售后订单结束

  moneyFormat: function (money) {
    if (money && money != null) {
      money = String(money)
      var left = money.split('.')[0],
        right = money.split('.')[1]
      right = right
        ? right.length >= 2
          ? '.' + right.substr(0, 2)
          : '.' + right + '0'
        : ''
      var temp = left
        .split('')
        .reverse()
        .join('')
        .match(/(\d{1,3})/g)
      return (
        (Number(money) < 0 ? '-' : '') +
        temp.join(',').split('').reverse().join('') +
        right
      )
    } else if (money === 0) {
      // 注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
      return '0'
    } else {
      return ''
    }
  },
  amount(number) {
    if (isNaN(number) || number == 0) {
      return '0.00'
    } else {
      return (number / 100).toFixed(2)
    }
  },
  formatName(name) {
    if (name) {
      let newStr
      if (name.length === 2) {
        newStr = name.substr(0, 1) + '*'
      } else if (name.length > 2) {
        let char = ''
        for (let i = 0, len = name.length - 2; i < len; i++) {
          char += '*'
        }
        newStr = name.substr(0, 1) + char + name.substr(-1, 1)
      } else {
        newStr = name
      }
      return newStr
    } else {
      return '未知'
    }
  },

  ThousandSeparator(input) {
    return (
      input &&
      input
        .toString()
        .replace(/(^|\s)\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
    )
  },
  SexFormat(value) {
    if (value == 1) {
      return '男'
    } else if (value == 0) {
      return '女'
    } else if (value == 2) {
      return '女'
    } else {
      return '未知'
    }
  },

  //手机号脱敏

  phoneNumberFilter: function (value) {
    if (value) {
      // let reg = getRegExp('^(\d{3})\d{4}(\d{4})$')

      return value.replace(/^(\d{3})\d{4}(\d+)/, '$1****$2')
    }
  },

  keepTwo(value) {
    // 截取当前数据到小数点后三位
    const itemVal = Number(value).toFixed(3)
    if (itemVal === 'NaN') {
      return '0.00'
    }
    const realVal = itemVal.substring(0, itemVal.length - 1)
    return realVal
  },
}

//定义下全局过滤器  往 {}里面加 逗号隔开
export default filters
